import React, { useEffect } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { Box, Grid, InputAdornment, Stack, TextField } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { useDispatch, useSelector } from "react-redux";
import { createValidationAllocationThunk } from "store/reducers/product/validationAllocationSlice";
import AutoCompleteListFormik from "components/AutoCompleteListFormik";
import {
  getProductValidationsThunk,
  productValidationSelector,
} from "store/reducers/product/productValidationSlice";

// const validation = yup.object().shape(
//   {
//     // category: yup.number().when(["sub_category", "product"], {
//     //   is: (sub_category, product) => sub_category || product,
//     //   then: yup.number(),
//     //   otherwise: yup.number().required("Please choose a category"),
//     // }),
//     // sub_category: yup.number().when(["category", "product"], {
//     //   is: (category, product) => category || product,
//     //   then: yup.number(),
//     //   otherwise: yup.number().required("Please choose a sub category"),
//     // }),
//     // product: yup.number().when(["sub_category", "category"], {
//     //   is: (sub_category, category) => category || sub_category,
//     //   then: yup.number(),
//     //   otherwise: yup.number().required("Please choose a product"),
//     // }),
//     validation: yup
//       .number("Enter validation")
//       .required("Please choose a validation"),
//   },
//   [
//     ["sub_category", "product"],
//     ["category", "product"],
//     ["sub_category", "category"],
//   ]
// );

const ValidationAllocationCreate = ({
  product_id = null,
  category_id = null,
  subcategory_id = null,
  fullGrid = false,
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getProductValidationsThunk());
  }, []);
  const validations = useSelector(productValidationSelector.selectAll);
  const formik = useFormik({
    initialValues: {
      category: category_id,
      sub_category: subcategory_id,
      product: product_id,
      validation: null,
    },
    // validationSchema: validation,

    onSubmit: (data) => {
      // console.log(data);
      dispatch(
        createValidationAllocationThunk({
          ...data,
          validation: data.validation.id,
        })
      );
    },
    validateOnChange: false,
  });

  const { loading } = useSelector((state) => state.productOffer);

  return (
    <>
    <Box marginTop={2}>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={1.5} paddingY={1}>
          <Grid item xs={12} md={fullGrid ? 12 : 8} lg={fullGrid ? 12 : 8}>
            <Stack spacing={2}>
              <AutoCompleteListFormik
                items={validations}
                name="name"
                label="Validations"
                formik={formik}
                formikName="validation"
                required={true}
              />
            </Stack>
          </Grid>
        </Grid>

        <LoadingButton
          variant="contained"
          type="submit"
          sx={{ paddingX: 10, marginTop: 1 }}
          loading={loading?.create === product_id}
        >
          Add
        </LoadingButton>
      </form>
    </Box>
    </>
  );
};

export default ValidationAllocationCreate;
